module.exports = __webpack_public_path__ + "img/dashboard.0cd9d445.svg";